export default function($) {
  document.querySelectorAll('.wpedon-select').forEach(select => {
    const container = document.createElement('div');
    container.className = 'donation-buttons';

    Array.from(select.options).forEach((option, i) => {
      if (!option.value) return;

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'donation-button';
      btn.textContent = option.textContent;
      btn.onclick = () => {
        container.querySelectorAll('.donation-button').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        select.value = option.value;
        select.dispatchEvent(new Event('change', {bubbles: true}));
      };

      if (i === 0) btn.classList.add('active');
      container.appendChild(btn);
    });

    select.parentNode.insertBefore(container, select.nextSibling);
    select.style.display = 'none';
  });

  document.querySelectorAll('.wpedon-container label').forEach(label => label.setAttribute('style', 'font-weight: 600; font-size: 1.25rem; margin-bottom: 0.5rem; text-align: center;') );
}
